// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_Extra from "../Data.Array.Extra/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Array_NonEmpty_Serialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_MenuCatalogueQuery from "../Restaumatic.Menu.V2.MenuCatalogueQuery/index.js";
import * as Restaumatic_Menu_V2_Parametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_CustomParameter from "../Restaumatic.Menu.V2.Types.CustomParameter/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_ItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Restaumatic_Menu_V2_Types_Modifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic_Menu_V2_Types_Product from "../Restaumatic.Menu.V2.Types.Product/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var MenuProductDetails = /* #__PURE__ */ (function () {
    function MenuProductDetails(value0) {
        this.value0 = value0;
    };
    MenuProductDetails.create = function (value0) {
        return new MenuProductDetails(value0);
    };
    return MenuProductDetails;
})();
var MenuComboDetails = /* #__PURE__ */ (function () {
    function MenuComboDetails(value0) {
        this.value0 = value0;
    };
    MenuComboDetails.create = function (value0) {
        return new MenuComboDetails(value0);
    };
    return MenuComboDetails;
})();
var CustomProductDetails = /* #__PURE__ */ (function () {
    function CustomProductDetails(value0) {
        this.value0 = value0;
    };
    CustomProductDetails.create = function (value0) {
        return new CustomProductDetails(value0);
    };
    return CustomProductDetails;
})();
var productName = function (locale) {
    return function (v) {
        if (v instanceof CustomProductDetails) {
            return v.value0.name;
        };
        if (v instanceof MenuProductDetails) {
            return Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(" / ")(Data_Functor.map(Data_Functor.functorArray)((function () {
                var $120 = Restaumatic_I18n_Types.getLocalization(locale);
                return function ($121) {
                    return $120((function (v1) {
                        return v1.name;
                    })($121));
                };
            })())(v.value0.parts));
        };
        if (v instanceof MenuComboDetails) {
            return Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(" + ")(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                return Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(" / ")(Data_Functor.map(Data_Functor.functorArray)((function () {
                    var $122 = Restaumatic_I18n_Types.getLocalization(locale);
                    return function ($123) {
                        return $122((function (v2) {
                            return v2.name;
                        })($123));
                    };
                })())(v1.parts));
            })(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Detail (line 202, column 3 - line 205, column 146): " + [ v.constructor.name ]);
    };
};
var productImage = function (v) {
    if (v instanceof CustomProductDetails) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof MenuProductDetails) {
        return Data_Array.head(Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
            return v1.image;
        })(v.value0.parts)));
    };
    if (v instanceof MenuComboDetails) {
        return Data_Array.head(Data_Array.catMaybes(Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidArray)(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
            return Data_Functor.map(Data_Functor.functorArray)(function (v2) {
                return v2.image;
            })(v1.parts);
        })(v.value0))));
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.Detail (line 209, column 3 - line 212, column 106): " + [ v.constructor.name ]);
};
var productFullTextDescription = function (locale) {
    var renderWithMultiplicity = function (v) {
        return (function () {
            var $56 = v.value1 > 1;
            if ($56) {
                return Data_Show.show(Data_Show.showInt)(v.value1) + "x ";
            };
            return "";
        })() + Restaumatic_I18n_Types.getLocalization(locale)(v.value0);
    };
    var renderPart = function (v) {
        return Data_String_Common.joinWith(" / ")(Data_Functor.map(Data_Functor.functorArray)((function () {
            var $124 = Restaumatic_I18n_Types.getLocalization(locale);
            return function ($125) {
                return $124((function (v1) {
                    return v1.choice;
                })($125));
            };
        })())(v.customParameters)) + Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(function (v1) {
            return Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(function ($126) {
                return (function (v2) {
                    return ", " + v2;
                })(renderWithMultiplicity($126));
            })(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v1.includedItems)(v1.addedItems));
        })(v.modifiers);
    };
    return function (v) {
        if (v instanceof MenuProductDetails) {
            return Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(", ")(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.map(Data_Functor.functorArray)((function () {
                var $127 = Restaumatic_I18n_Types.getLocalization(locale);
                return function ($128) {
                    return $127((function (v1) {
                        return v1.choice;
                    })($128));
                };
            })())(v.value0.customParameters))(Data_Functor.map(Data_Functor.functorArray)(renderWithMultiplicity)(Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Semigroup.append(Data_Semigroup.semigroupFn(Data_Semigroup.semigroupArray))(function (v1) {
                return v1.includedItems;
            })(function (v1) {
                return v1.addedItems;
            }))(v.value0.modifiers))))) + (function () {
                if (v.value0.parts.length === 1) {
                    return renderPart(v["value0"]["parts"][0]);
                };
                return Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Monoid.monoidString)(function (part) {
                    return "; " + (Restaumatic_I18n_Types.getLocalization(locale)(part.name) + (": " + renderPart(part)));
                })(v.value0.parts);
            })();
        };
        return "";
    };
};
var parameterDetails = function (v) {
    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.findCustomParameter(v.value0))(function (parameter) {
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.orError(Data_Map_Ordered.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v.value1)((Data_Newtype.unwrap()(parameter)).choices))(function (v1) {
            return "Parameter choice not found";
        }))(function (choice) {
            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                parameter: Data_Record.getField(Restaumatic_Menu_V2_Types_CustomParameter.hasFieldCustomParameter(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "name";
                    }
                })()))(Type_Proxy["Proxy"].value)(parameter),
                choice: Data_Record.getField(Restaumatic_Menu_V2_Types_CustomParameter.hasFieldCustomParameterCh(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "name";
                    }
                })()))(Type_Proxy["Proxy"].value)(choice)
            });
        });
    });
};
var modifierDetails = function (menuEnv) {
    return function (v) {
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.findModifier(v.value0))(function (modifier) {
            var visible = Restaumatic_Menu_V2_Parametric.isPossible(Restaumatic_Menu_V2_Parametric.isParametricPossibleBoole)(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifier(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "availableWhen";
                }
            })()))(Type_Proxy["Proxy"].value)(modifier))(Restaumatic_Menu_V2_Parametric.fromInternalParameterValues(menuEnv.params)) && Data_Eq.notEq(Restaumatic_Menu_V2_Types_Modifier.eqModifierDisplayMode)(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifier(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "displayMode";
                }
            })()))(Type_Proxy["Proxy"].value)(modifier))(Restaumatic_Menu_V2_Types_Modifier.ModifierHidden.value);
            var selectedItems = Data_Newtype.unwrap()(v.value1);
            var items = Restaumatic_Menu_V2_MenuCatalogue.modifierItems(modifier);
            var itemsOMS = Data_OrderedMultiSet.fromArray(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Map_Ordered.keys(items));
            var displayItem = function (v1) {
                return Data_Functor.map(Data_Maybe.functorMaybe)((function () {
                    var $129 = Data_Function.flip(Data_Tuple.Tuple.create)(v1.value1);
                    return function ($130) {
                        return $129((function (v2) {
                            return Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "name";
                                }
                            })()))(Type_Proxy["Proxy"].value)(v2);
                        })($130));
                    };
                })())(Data_Map_Ordered.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v1.value0)(items));
            };
            var displayItems = function (items$prime) {
                return Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)(displayItem)(Data_OrderedMultiSet.toOccurArray(items$prime)));
            };
            var defaultItems = (function () {
                var v1 = (Data_Newtype.unwrap()(modifier)).exchangePolicy;
                if (v1 instanceof Restaumatic_Menu_V2_Types_Modifier.NotIncluded) {
                    return Data_OrderedMultiSet.empty;
                };
                return Restaumatic_Menu_V2_MenuCatalogue.modifierDefaultChoices(modifier);
            })();
            var defaultItemsSet = Data_OrderedMultiSet.toMultiSet(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(defaultItems);
            var includedItems = Data_OrderedMultiSet.restoreOrder(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(defaultItems)(Data_MultiSet.intersection(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(defaultItemsSet)(selectedItems));
            var removedItems = Data_OrderedMultiSet.restoreOrder(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(defaultItems)(Data_MultiSet.difference(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(defaultItemsSet)(selectedItems));
            var addedItems = Data_OrderedMultiSet.restoreOrder(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(itemsOMS)(Data_MultiSet.difference(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(selectedItems)(defaultItemsSet));
            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)((function () {
                if (visible) {
                    return new Data_Maybe.Just({
                        removedItems: displayItems(removedItems),
                        addedItems: displayItems(addedItems),
                        includedItems: displayItems(includedItems)
                    });
                };
                return Data_Maybe.Nothing.value;
            })());
        });
    };
};
var partDetails = function (menuEnv) {
    return function (v) {
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.findProduct(v.productId))(function (product) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(parameterDetails)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.customParameters))))(function (customParametersDetailsVal) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Array.catMaybes)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(modifierDetails(menuEnv))(Data_Array_Extra.restoreOrderWith(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Tuple.fst)(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "divisibleModifiersOrder";
                    }
                })()))(Type_Proxy["Proxy"].value)(product))(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.modifiers))))))(function (modifierDetailsVal) {
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable["for"](Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Traversable.traversableMaybe)(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(product)(function (v1) {
                        return v1.availabilitySchedule;
                    }))(Restaumatic_Menu_V2_MenuCatalogueQuery.findAvailabilitySchedule))(function (availabilityMb) {
                        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                            customParameters: customParametersDetailsVal,
                            modifiers: modifierDetailsVal,
                            image: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Newtype.unwrap())(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "photo";
                                }
                            })()))(Type_Proxy["Proxy"].value)(product)),
                            name: Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "name";
                                }
                            })()))(Type_Proxy["Proxy"].value)(product),
                            availability: Restaumatic_UnwrapOperators.mapUnwrapFlipped(Data_Maybe.functorMaybe)()(availabilityMb)(function (v1) {
                                return v1.availability;
                            })
                        });
                    });
                });
            });
        });
    };
};
var menuProductDetails = function (menuEnv) {
    return function (v) {
        var productId = Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(v.parts)(Data_Array_NonEmpty.head))(function (v1) {
            return v1.productId;
        });
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.findProduct(productId))(function (product) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(function ($131) {
                return Restaumatic_Menu_V2_MenuCatalogueQuery.findProduct((function (v1) {
                    return Data_Record.getField(Restaumatic_Menu_V2_Types_CartToOrder.hasFieldCartProductPartKe(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "productId";
                        }
                    })()))(Type_Proxy["Proxy"].value)(v1);
                })($131));
            })(Data_Array.fromFoldable(Data_Array_NonEmpty_Serialized.foldableNonEmptyArray)(v.parts)))(function (products) {
                var modifierOrder = Data_Array.nub(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Control_Bind.bind(Control_Bind.bindArray)(products)(function (v1) {
                    return Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "nonDivisibleModifiersOrder";
                        }
                    })()))(Type_Proxy["Proxy"].value)(v1);
                }));
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(parameterDetails)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.customParameters))))(function (customParametersDetailsVal) {
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Array.catMaybes)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(modifierDetails(menuEnv))(Data_Array_Extra.restoreOrderWith(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Tuple.fst)(modifierOrder)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.modifiers))))))(function (modifierDetailsVal) {
                        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)((function () {
                            var $132 = partDetails(menuEnv);
                            var $133 = Data_Newtype.unwrap();
                            return function ($134) {
                                return $132($133($134));
                            };
                        })())(Data_Array.fromFoldable(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Newtype.unwrap()(v.parts))))(function (partDetailsVal) {
                            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                                customParameters: customParametersDetailsVal,
                                modifiers: modifierDetailsVal,
                                parts: partDetailsVal,
                                productCategoryId: Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "category";
                                    }
                                })()))(Type_Proxy["Proxy"].value)(product),
                                itemId: new Restaumatic_Menu_V2_Types_ItemId.ProductItem(productId),
                                customParametersMap: Data_Newtype.unwrap()(v.customParameters)
                            });
                        });
                    });
                });
            });
        });
    };
};
var menuComboDetails = function (menuEnv) {
    return function (v) {
        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.findCombo(v.comboId))(function (combo) {
            return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Array.catMaybes)(Data_Traversable["for"](Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Traversable.traversableArray)(Data_Map_Ordered.toArray((Data_Newtype.unwrap()(combo)).elements))(function (v1) {
                var v2 = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v1.value0)(Data_Newtype.unwrap()(v.elements));
                if (v2 instanceof Data_Maybe.Nothing) {
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(Data_Maybe.Nothing.value);
                };
                if (v2 instanceof Data_Maybe.Just) {
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.orError(Data_Map_Ordered.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(v2.value0.comboChoiceId)((Data_Newtype.unwrap()(v1.value1)).choices))(function (v3) {
                        return "Combo choice not found";
                    }))(function (choice) {
                        var productId = (Data_Newtype.unwrap()(choice)).product;
                        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_V2_MenuCatalogueQuery.findProduct(productId))(function (product) {
                            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(parameterDetails)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v2.value0.customParameters))))(function (customParametersDetailsVal) {
                                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(Data_Array.catMaybes)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(modifierDetails(menuEnv))(Data_Array_Extra.restoreOrderWith(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Tuple.fst)(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "nonDivisibleModifiersOrder";
                                    }
                                })()))(Type_Proxy["Proxy"].value)(product))(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v2.value0.modifiers))))))(function (modifierDetailsVal) {
                                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(partDetails(menuEnv)({
                                        customParameters: v2.value0.customParameters,
                                        modifiers: v2.value0.modifiers,
                                        productId: productId
                                    }))(function (partDetailsVal) {
                                        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(new Data_Maybe.Just({
                                            customParameters: customParametersDetailsVal,
                                            modifiers: modifierDetailsVal,
                                            parts: [ partDetailsVal ],
                                            productCategoryId: Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(product)(function (v3) {
                                                return v3.category;
                                            }),
                                            itemId: new Restaumatic_Menu_V2_Types_ItemId.ComboItem(v.comboId),
                                            customParametersMap: Data_Newtype.unwrap()(v2.value0.customParameters)
                                        }));
                                    });
                                });
                            });
                        });
                    });
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Detail (line 90, column 5 - line 108, column 12): " + [ v2.constructor.name ]);
            }));
        });
    };
};
var productDetails = function (menuEnv) {
    return function (v) {
        if (v instanceof Restaumatic_Cart_ProductKey.CustomProduct) {
            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(new CustomProductDetails({
                name: Data_Record.getField(Restaumatic_Cart_ProductKey.hasFieldCustomProductKey(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "name";
                    }
                })()))(Type_Proxy["Proxy"].value)(v.value0)
            }));
        };
        if (v instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
            return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(MenuProductDetails.create)(menuProductDetails(menuEnv)(v.value0));
        };
        if (v instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
            return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(MenuComboDetails.create)(menuComboDetails(menuEnv)(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Detail (line 58, column 3 - line 62, column 71): " + [ v.constructor.name ]);
    };
};
var genericProductDetails = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new MenuProductDetails(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new MenuComboDetails(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new CustomProductDetails(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Detail (line 52, column 1 - line 52, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof MenuProductDetails) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof MenuComboDetails) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof CustomProductDetails) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.Detail (line 52, column 1 - line 52, column 66): " + [ x.constructor.name ]);
    }
};
var showProductDetails = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductDetails)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParametersMap";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "itemId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productCategoryId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt)))))))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameter";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))))))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Calendar_Types_Availability.showWeeklyAvailability))))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt)))))))(Restaumatic_Menu_V2_Types_ItemId.showItemId))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameter";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))))))))({
        reflectSymbol: function () {
            return "MenuProductDetails";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParametersMap";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "itemId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productCategoryId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt)))))))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameter";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))))))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Calendar_Types_Availability.showWeeklyAvailability))))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt))))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString))(Data_Show.showInt)))))))(Restaumatic_Menu_V2_Types_ItemId.showItemId))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameter";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))))))))({
        reflectSymbol: function () {
            return "MenuComboDetails";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CustomProductDetails";
        }
    }))))
};
export {
    MenuProductDetails,
    MenuComboDetails,
    CustomProductDetails,
    productDetails,
    productName,
    productImage,
    productFullTextDescription,
    genericProductDetails,
    showProductDetails
};
//# sourceMappingURL=index.js.map
